import { HttpHeaders } from "@angular/common/http"

export class MyHeader{

    public getHeader() : HttpHeaders{
        let headers = new HttpHeaders();
        headers=headers.append('Authorization', 'Bearer ' + JSON.parse(localStorage.getItem('token') ?? '""').access_token);

        return headers;

    }

    public tokenHeader() : HttpHeaders{
      let headers = new HttpHeaders()
      .append('content-type', 'application/x-www-form-urlencoded')
      .append('Skip-Auth', '');
      return headers;

  }
}
